import { Icon, IconProps } from "@chakra-ui/react";

export function ArrowUpIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 20 20" fill="currentColor" {...props}>
      <path d="M18.3333 13.75L9.99951 5.41656L1.66577 13.75L18.3333 13.75Z" />
    </Icon>
  );
}
